// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2QQI7","clinicsSelect":"styles_clinicsSelect__1XsWX"};